import React from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { ColumnButton, DivBackgroundOpacity } from "@utils/extra-style";

const Operation = (props) => {
  const { t, data } = props;

  return (
    <>
      <DivBackgroundOpacity>
        {data.serviceType === "EVACUATION" && (
          <ColumnButton
            border="#32A728"
            background="#32A728"
            marginRight="10px"
          >
            {t("PRODUCTS_FILTER_REMOVAL")}
          </ColumnButton>
        )}
        {data.serviceType === "DELIVERY" && (
          <ColumnButton
            border="#0A4986"
            background="#0A4986"
            marginRight="10px"
          >
            {t("PRODUCTS_FILTER_SUPPLY")}
          </ColumnButton>
        )}
        {data.serviceType === "NONE" && (
          <ColumnButton
            border="#438097"
            background="#438097"
            marginRight="10px"
          >
            {t("PRODUCTS_FILTER_OTHER")}
          </ColumnButton>
        )}
      </DivBackgroundOpacity>
    </>
  );
};

Operation.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(Operation);
